const PageWrap: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <div>{children}</div>;
};

export default PageWrap;
